import { BodySection, TopSection } from '../components';

export function TermsPages() {
  return (
    <div>
      <TopSection />
      <BodySection />
    </div>
  );
}
